import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { SkeletonRegistryDraftQuestion } from './question/SkeletonRegistryDraftQuestion';
export class DraftSkeletons extends SkeletonRegistryCategory {
    label = 'Draft';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_q = new SkeletonRegistryDraftQuestion(this);
}
